import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

interface GetProfilePageBannerUploadUrlParams {
	fileExtension?: string
}

export default function useMutationGetProfilePageBannerUploadUrl() {
	return useMutation({
		mutationFn: ({
			fileExtension = 'webp',
		}: GetProfilePageBannerUploadUrlParams) =>
			FileService.getProfilePageBannerUploadUrl(fileExtension),
	})
}
